/* eslint-disable @scandipwa/scandipwa-guidelines/file-structure */
/**
 * Google Tag Manager frontend compatibility for ScandiPWA
 * @copyright Scandiweb, Inc. All rights reserved.
 */

/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import {
    getAddToCartData, getApplyCouponEventData, getRemoveFromCartData, getViewCartData
} from '../data/cart';
import {
    GTM_EVENT_KEY_ADD_TO_CART,
    GTM_EVENT_KEY_APPLY_COUPON,
    GTM_EVENT_KEY_REMOVE_FROM_CART,
    GTM_EVENT_KEY_VIEW_CART
} from '../util/events';
import { pushToDataLayer } from '../util/push';

/** @namespace Scandiweb/Gtm/Event/Cart/fireViewCartEvent */
export const fireViewCartEvent = async (currencyCode, customerId) => {
    // ^^^ not using debounce, as many cart edits may happen at once
    pushToDataLayer({
        event: GTM_EVENT_KEY_VIEW_CART,
        customerId,
        ...await getViewCartData(currencyCode)
    });
};

/** @namespace Scandiweb/Gtm/Event/Cart/fireAddToCartEvent */
export const fireAddToCartEvent = async (item, currencyCode, customerId) => {
    // ^^^ not using debounce, as many cart edits may happen at once
    pushToDataLayer({
        event: GTM_EVENT_KEY_ADD_TO_CART,
        customerId,
        ...await getAddToCartData(item, currencyCode)
    });
};

/** @namespace Scandiweb/Gtm/Event/Cart/fireRemoveFromCartEvent */
export const fireRemoveFromCartEvent = async (item, currencyCode, customerId) => {
    // ^^^ not using debounce, as many cart edits may happen at once
    pushToDataLayer({
        event: GTM_EVENT_KEY_REMOVE_FROM_CART,
        customerId,
        ...await getRemoveFromCartData(item, currencyCode)
    });
};

/** @namespace Scandiweb/Gtm/Event/Cart/fireApplyCouponEvent */
export const fireApplyCouponEvent = async (coupon, customerId) => {
    pushToDataLayer({
        event: GTM_EVENT_KEY_APPLY_COUPON,
        customerId,
        ...await getApplyCouponEventData(coupon)
    });
};
